import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { homeAction } from "@redux/modules";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

// react-icons
import { FaUser } from 'react-icons/fa';

const HomeLeaderboard = () => {
  const dispatch = useDispatch();

  const loginSettings = useSelector(
    (store) => store.auth.loginSettings
  );

  const [leaderboard, setLeaderboard] = useState([]);

  const getLeaderboard = () => {
    dispatch(homeAction.getLeaderboard()).then((e) => {
      if (e.isHttpSuccess) {
        setLeaderboard(e.data.boardEmployeeDTOList);
      }
    });
  };

  useEffect(() => {
    getLeaderboard();
    return () => {};
  }, [dispatch]);

  const topThree = leaderboard?.slice(0, 3);

  const reorderedTopThree = [
    // Reorder the top three items to display them in the correct style
    topThree[1],
    topThree[0],
    topThree[2],
  ];

  const indexHelper = (index) => {
    if (index === 0) {
      return 2;
    } else if (index === 1) {
      return 1;
    } else if (index === 2) {
      return 3;
    }
  };

  const others = leaderboard?.slice(3, 9);

  // Helper function to group items into pairs
  const groupIntoPairs = (array) => {
    const pairs = [];
    for (let i = 0; i < array.length; i += 2) {
      pairs.push(array.slice(i, i + 2));
    }
    return pairs;
  };

  const othersInPairs = groupIntoPairs(others);

  return (
    <section className="leaderboard-section pb-5 pt-5">
      <Row className="justify-content-center">
        <Col xs={12} xl={8}>
          <div>
            <div className="leaderboard-header">
              <h3 className="leaderboard-title">Liderler Tablosu</h3>
            </div>

            <div className="leaderboard-content">
              <div className="leaderboard-winners mt-5">
                {reorderedTopThree.map((item, index) => (
                  <div
                    key={index}
                    className={indexHelper(index) === 3 ? "winner-container winner-3 mt-5" : indexHelper(index) === 2 ? `winner-container winner-2 mt-4` : `winner-container winner-${indexHelper(index)}`}
                    style={{ background: loginSettings?.blue }}
                  >
                    {item?.icon ? (
                      <img
                        className="winner-image"
                        src={item?.icon}
                        alt="winner"
                      />
                    ) : (
                      <div
                        className="m-auto shadow-sm rounded-circle bg-gray d-flex flex-col justify-content-center align-items-center"
                        style={{ width: 100, height: 100 }}
                      >
                        <FaUser
                          className="text-gray-special"
                          style={{ width: 64, height: 64, color: "#fff" }}
                        />
                      </div>
                    )}
                    <p className="winner-name">{item?.employeeFullName}</p>
                    <p className="winner-points">{item?.value} Puan</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="leaderboard-footer text-center mt-5">
              <Link
                to="/leaderboard"
                className="btn btn-blue rounded-pill py-sm-3 py-2 px-sm-4 px-3"
              >
                Tümünü Gör
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default HomeLeaderboard;
